import { Collapse } from "@mantine/core";
import { DataTableRowExpansionProps } from "./auto-table-row-expansion.types";
import { useRowExpansionStatus } from "../auto-table.hooks";
import { Table } from "../../table";

export function DataTableRowExpansion({ open, colSpan, content, collapseProps }: DataTableRowExpansionProps) {
    const { expanded, visible } = useRowExpansionStatus(open, collapseProps?.transitionDuration);

    return visible ? (
        <>
            {/* add an empty row to maintain striped rows consistency */}
            <Table.Tr />
            <Table.Tr data-highlighted={expanded} data-expanded={expanded}>
                <Table.Td className="mantine-datatable-row-expansion-cell" colSpan={colSpan}>
                    <Collapse in={expanded} {...collapseProps}>
                        <div className="mantine-datatable-row-expansion-cell-content">{content()}</div>
                    </Collapse>
                </Table.Td>
            </Table.Tr>
        </>
    ) : null;
}
